import {
  createScopedUiRepository,
  type ScopedStoredRecord,
} from "@/storage/scopedUiRepository";
import { UI_COMPONENT_SPECS_STORE } from "@/storage/uiDatabase";
import type { UiComponentSpec } from "@/types/ui";

export interface StoredUiComponentSpec extends UiComponentSpec, ScopedStoredRecord {}

export const EMPTY_UI_COMPONENT_SPECS: readonly StoredUiComponentSpec[] =
  Object.freeze([]);

const uiComponentSpecsRepository = createScopedUiRepository<
  UiComponentSpec,
  StoredUiComponentSpec
>({
  emptySnapshot: EMPTY_UI_COMPONENT_SPECS,
  sortRecords: sortUiComponentSpecs,
  storeName: UI_COMPONENT_SPECS_STORE,
});

export const getUiComponentSpecsSnapshot = uiComponentSpecsRepository.getSnapshot;
export const subscribeUiComponentSpecs = uiComponentSpecsRepository.subscribe;
export const hydrateUiComponentSpecs = uiComponentSpecsRepository.hydrate;
export const replaceUiComponentSpecs = uiComponentSpecsRepository.replace;

function sortUiComponentSpecs<T extends UiComponentSpec>(specs: readonly T[]): T[] {
  return [...specs].sort((a, b) => a.kind.localeCompare(b.kind));
}
